import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { getFilterValues, getAppliedFilter } from '../sbSharedRefineMenuHelpers.ts';

// components
import { SbSharedRefineMenuRadioSelect } from './SbSharedRefineMenuRadioSelect.jsx';
import { SbSharedRefineMenuExpandableItemList } from '../SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList.tsx';

const SbSharedRefineMenuRadioSelectListComponent = props => {
    const {
        values,
        allLabel,
        filterName,
        totalCount,
        itemSearch,
        notDismissable,
        collapsedItemCount,
        shouldUseExpandableList = true,
        showAllOption,
        trackingOptions,
    } = props;
    const { appliedFilters } = itemSearch;
    const hasVectorSearchResults = !!itemSearch?.searchResultData?.vectorResultCount;
    const appliedFilter = getAppliedFilter(appliedFilters, filterName);
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    let canBeDismissed;

    if (notDismissable !== undefined) {
        canBeDismissed = notDismissable;
    } else {
        canBeDismissed = appliedFilter ? appliedFilter.canBeDismissed : true;
    }

    if (!shouldUseExpandableList) {
        return (
            <SbSharedRefineMenuRadioSelect
                allLabel={allLabel}
                totalCount={totalCount}
                filterName={filterName}
                valuesToShow={values}
                canBeDismissed={canBeDismissed}
                appliedFilterValues={appliedFilterValues}
                trackingOptions={trackingOptions}
                hasVectorSearchResults={hasVectorSearchResults}
            />
        );
    }

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
            collapsedItemCount={collapsedItemCount}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuRadioSelect
                    allLabel={allLabel}
                    totalCount={totalCount}
                    filterName={filterName}
                    valuesToShow={valuesToShow}
                    canBeDismissed={canBeDismissed}
                    appliedFilterValues={appliedFilterValues}
                    showAllOption={showAllOption}
                    trackingOptions={trackingOptions}
                    hasVectorSearchResults={hasVectorSearchResults}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbSharedRefineMenuRadioSelectListComponent.propTypes = {
    allLabel: PropTypes.string,
    values: PropTypes.array.isRequired,
    totalCount: PropTypes.number,
    notDismissable: PropTypes.bool,
    collapsedItemCount: PropTypes.number,
    filterName: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
    shouldUseExpandableList: PropTypes.bool,
    showAllOption: PropTypes.bool,
    trackingOptions: PropTypes.object,
};

export const SbSharedRefineMenuRadioSelectList = createFragmentContainer(
    SbSharedRefineMenuRadioSelectListComponent,
    {
        itemSearch: graphql`
            fragment SbSharedRefineMenuRadioSelectList_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    localizedFilterName
                    canBeDismissed
                    values {
                        urlLabel
                        linkReference
                        count
                        displayName
                    }
                }
                searchResultData {
                    vectorResultCount
                }
            }
        `,
    }
);
